import React from "react";

const TrashIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="19"
			height="18"
			viewBox="0 0 19 18"
			{...props}>
			<path
				d="M13.6121 7.01828C13.7303 7.01828 13.8375 7.07048 13.9222 7.15868C14.0011 7.25288 14.0409 7.36988 14.0294 7.49347C14.0294 7.53427 13.7136 11.5782 13.5332 13.2804C13.4202 14.325 12.7551 14.9592 11.7575 14.9766C10.9904 14.994 10.2406 15 9.50233 15C8.71852 15 7.95201 14.994 7.20797 14.9766C6.24377 14.9532 5.57812 14.3076 5.47092 13.2804C5.28534 11.5722 4.97528 7.53427 4.96951 7.49347C4.96375 7.36988 5.00294 7.25288 5.08247 7.15868C5.16086 7.07048 5.27382 7.01828 5.39254 7.01828H13.6121ZM10.7236 3C11.2475 3 11.7155 3.3702 11.8509 3.89819L11.9477 4.33619C12.0261 4.69318 12.3316 4.94578 12.6831 4.94578H14.411C14.6415 4.94578 14.8334 5.13958 14.8334 5.38618V5.61417C14.8334 5.85477 14.6415 6.05457 14.411 6.05457H4.58977C4.35867 6.05457 4.16675 5.85477 4.16675 5.61417V5.38618C4.16675 5.13958 4.35867 4.94578 4.58977 4.94578H6.3176C6.66858 4.94578 6.97404 4.69318 7.053 4.33679L7.14348 3.92759C7.2841 3.3702 7.74689 3 8.27654 3H10.7236Z"
				fill={props.fill || "#A0A3BD"}
			/>
		</svg>
	);
};

export default TrashIcon;
